import React, { useContext } from "react";
import { hideModal, showModal } from "../../../context/Actions/modal/modal";
import TildeOkCircle from "../../../assets/images/generico/TildeOkCircle";
import { PortalContext } from "../../../context/Provider";
import CardTemplate from "../../Genericos/CardTemplate/CardTemplate";
import "./CardFamiliarStyle.css";

const CardFamiliar = ({ handleClickAgregaFamiliar }) => {
  const { modalDispatch, textosState } = useContext(PortalContext);

  const dissmiss = () => {
    hideModal()(modalDispatch);
  };
  const showModalBeneficios = () => {
    showModal(
      "Genericos/Mensaje/Mensaje",
      {
        titulo: "Beneficios del Portal Web",
        texto: (
          <div style={{ marginLeft: 10, marginBottom: 60 }}>
            {textosState.textos.data === null
              ? ""
              : Array.from(textosState.textos.data.beneficios).map(
                  (item, index) => {
                    return (
                      <React.Fragment key={index}>
                        <TildeOkCircle
                          texto={item.descripcion}
                          colorTilde="var(--color-black)"
                          colorTexto="c-black"
                        />
                      </React.Fragment>
                    );
                  }
                )}
          </div>
        ),
        dissmiss: dissmiss,
      },
      [
        {
          text: "Agregar luego",
          clase: "btn-Mensaje b-latex30 rb16m c-latex30",
          accion: dissmiss,
        },
        {
          text: "Agregar un familiar",
          clase: "btn-Mensaje-1 rb16m bgc-primary c-white",
          accion: handleClickAgregaFamiliar,
        },
      ],
      "centro"
    )(modalDispatch);
  };
  return (
    <React.Fragment>
      <CardTemplate
        tituloCard="Agregar un miembro familiar"
        bodyCard={
          <React.Fragment>
            <h3
              className="ptur-card-familiar-texto1 rb16t"
              style={{ marginTop: 23 }}
            >
              Tu grupo familiar puede disfrutar de todos los beneficios del
              Portal Online. Como sacar turnos, hacer consultas y visualizar
              imágenes e informes del familiar.
            </h3>
            <h3 className="ptur-card-familiar-texto2 rb16t">
              Vos también podés sacar turnos por ellos.
            </h3>
            <div className="ptur-card-btn-container rb16m">
              <button
                className="bgc-primary c-white ptur-card-btn-agregar-familiar"
                onClick={handleClickAgregaFamiliar}
              >
                <span className="rb18m">Agregar un familiar</span>
              </button>
              {textosState.textos.data?.beneficios ? (
                textosState.textos.data?.beneficios?.length <= 0 ? (
                  ""
                ) : (
                  <div className="ptur-card-familiar-beneficios">
                    <button
                      onClick={showModalBeneficios}
                      className="ptur-card-familiar-beneficiosBtn rb16m"
                    >
                      Ver todos los beneficios
                    </button>
                  </div>
                )
              ) : (
                ""
              )}
            </div>
          </React.Fragment>
        }
      />
    </React.Fragment>
  );
};

export default CardFamiliar;
